import Skeleton from "react-loading-skeleton";
import { Box } from "../Box/Box";
import { Text } from "../Text/Text";

import { Location as Loc } from "~/types";
import { TextButton } from "../TextButton/TextButton";
import { useRouter } from "next/navigation";

export function LocationPanel({
  loc,
  canChangeLocation,
  skeleton,
}: {
  loc?: Loc;
  canChangeLocation: boolean;
  skeleton: boolean;
}) {
  const router = useRouter();

  return (
    <>
      <Box width="full" display="flex" alignItems={"flexEnd"}>
        <Text weight="semi-strong" size="xlarge" font="accent">
          {skeleton ? <Skeleton width={200} /> : loc?.address?.locality}
        </Text>
        {!skeleton && canChangeLocation && (
          <Box style={{ marginLeft: "auto" }}>
            <TextButton onClick={() => router.push("/")}>
              Change Store
            </TextButton>
          </Box>
        )}
      </Box>
      <Text
        color="neutral-600"
        font="special"
        weight="semi-strong"
        size="large"
      >
        {skeleton ? <Skeleton width={80} /> : loc?.address?.street}
      </Text>
      <Text
        color="neutral-600"
        font="special"
        weight="semi-strong"
        size="large"
      >
        {skeleton ? <Skeleton width={160} /> : <>Phone: {loc?.phoneNumber}</>}
      </Text>
    </>
  );
}
